import React from 'react';
import { Flag } from 'lucide-react';
import type { Priority } from '../../types';

interface PrioritySelectorProps {
  value: Priority;
  onChange: (priority: Priority) => void;
}

export function PrioritySelector({ value, onChange }: PrioritySelectorProps) {
  const priorities: Array<{ value: Priority; label: string; color: string }> = [
    { value: 'high', label: 'High', color: 'text-red-500 bg-red-500/20' },
    { value: 'medium', label: 'Medium', color: 'text-yellow-500 bg-yellow-500/20' },
    { value: 'low', label: 'Low', color: 'text-green-500 bg-green-500/20' },
  ];

  return (
    <div className="flex items-center gap-2">
      <Flag className="w-4 h-4 text-gray-400" />
      <div className="flex gap-2">
        {priorities.map((priority) => (
          <button
            key={priority.value}
            type="button"
            onClick={() => onChange(priority.value)}
            className={`px-3 py-1.5 rounded-lg text-sm transition-colors ${
              value === priority.value
                ? priority.color
                : 'bg-black/20 hover:bg-black/30'
            }`}
          >
            {priority.label}
          </button>
        ))}
      </div>
    </div>
  );
}